import { memo, useRef, type PropsWithChildren, type ReactNode } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { usePuzzleNavigationContext } from '../../context.tsx';
import { HeaderInputWrapper, HeaderWrapper, ItemsWrapper, Wrapper } from './styled.ts';

type ItemsListProps = PropsWithChildren<{
  header: ReactNode;
  companySelect?: ReactNode;
  searchInput: ReactNode;
  timer?: ReactNode;
  footer: ReactNode;
  mobileHeaderHeight: number;
}>;

export const ItemsList = memo(function ItemsList({
  children,
  header,
  companySelect,
  searchInput,
  timer,
  footer,
  mobileHeaderHeight,
}: ItemsListProps) {
  const { isCollapsedNav, activeKey, setActiveKey } = usePuzzleNavigationContext();

  const itemsWrapper = useRef<HTMLDivElement>(null);

  const handleOnScroll = useCallbackRef(() => {
    if (isCollapsedNav && activeKey) {
      setActiveKey(null);
    }
  });

  return (
    <Wrapper $collapsed={isCollapsedNav} data-collapsed={isCollapsedNav ? 'true' : 'false'}>
      <HeaderWrapper $isCollapsedNav={isCollapsedNav} $isCompanySwitchView={!!companySelect} $mobileHeaderHeight={mobileHeaderHeight}>
        {header}
        {(companySelect || searchInput || timer) && (
          <HeaderInputWrapper $isCollapsedNav={isCollapsedNav}>
            {companySelect}
            {searchInput}
            {timer}
          </HeaderInputWrapper>
        )}
      </HeaderWrapper>
      <ItemsWrapper ref={itemsWrapper} onScroll={handleOnScroll}>
        {children}
      </ItemsWrapper>
      {footer}
    </Wrapper>
  );
});
